import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'next-i18next';
import StoreLogo from '@components/StoreLogo';
import Link from 'next/link';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '14px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  storeLinks: {
    display: 'flex',
  },
  storeLinkItem: {
    padding: '0 37px',
    '&:last-child': {
      paddingRight: 0,
    },
  },
  storeLink: {
    color: '#31415E',
  },
}));

const StoreNavigation = ({ facebookPageName, facebookPageId }) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  return (
    <div className={[classes.root, 'container'].join(' ')}>
      <div>
        <StoreLogo facebookPageName={facebookPageName} facebookPageId={facebookPageId} />
      </div>
      <div className={classes.storeLinks}>
        <div className={classes.storeLinkItem}>
          <Link href="/store">
            <a className={classes.storeLink}>Home</a>
          </Link>
        </div>
        <div className={classes.storeLinkItem}>
          <Link href="/store">
            <a className={classes.storeLink}>Products</a>
          </Link>
        </div>
        <div className={classes.storeLinkItem}>
          <Link href="/store">
            <a className={classes.storeLink}>Delivery Method</a>
          </Link>
        </div>
        <div className={classes.storeLinkItem}>
          <Link href="/store">
            <a className={classes.storeLink}>About Us</a>
          </Link>
        </div>
      </div>
    </div>
  );
};

StoreNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
  facebookPageName: PropTypes.string,
  facebookPageId: PropTypes.string,
};

export default StoreNavigation;
